<script>

export default {
  name: "TheEducationAttestationStatisticsTable",

  props: {
    statistics: Array,
    educationalCode: String,
    educationalName: String,
  },
}
</script>

<template>
  <v-simple-table>
    <template v-slot:default>
      <thead :style="{'height': '100px'}">
      <tr>
        <th rowspan="3" :style="{'width': '75px'}">Код направления подготовки/специальности</th>
        <th rowspan="3">Наименование  направления подготовки/специальности</th>
        <th rowspan="3" :style="{'width': '75px'}">Группа</th>
        <th rowspan="3" :style="{'width': '55px'}">Кол-во аттестуемых, чел.</th>
        <th colspan="2" rowspan="2">Аттестованно</th>
        <th colspan="5">Не аттестовано</th>
        <th rowspan="3">Дисциплины, по которым получено наибольшее кол-во неаттестаций</th>
      </tr>
      <tr>
        <th colspan="2">всего</th>
        <th colspan="3">в том числе по кол-ву дисциплин, чел.</th>
      </tr>
      <tr>
        <th>чел.</th>
        <th>%</th>
        <th>чел.</th>
        <th>%</th>
        <th>одной</th>
        <th>двум</th>
        <th>трем и более</th>
      </tr>
      </thead>
      <tbody>
      <tr
        v-for="group_statistic in statistics"
        :key="group_statistic.groupName"
      >
        <td>{{educationalCode}}</td>
        <td>{{educationalName}}</td>
        <td>{{group_statistic.groupName}}</td>
        <td class="text-center">{{group_statistic.groupSize}}</td>
        <td>{{group_statistic.attestStudentsCount}}</td>
        <td>{{group_statistic.attestStudentsPercent}}%</td>
        <td>{{group_statistic.notAttestStudentsCount}}</td>
        <td>{{group_statistic.notAttestStudentsPercent}}%</td>
        <td>{{group_statistic.notAttestOneDisciplineCount}}</td>
        <td>{{group_statistic.notAttestTwoDisciplineCount}}</td>
        <td>{{group_statistic.notAttestThreeAndMoreDisciplineCount}}</td>
        <td>
          <div
            v-for="discipline in group_statistic.ratingNonCertificatedDisciplines"
          >
            {{group_statistic.ratingNonCertificatedDisciplines.indexOf(discipline) + 1}}.
            {{discipline.name}}
            : {{discipline.count}}
          </div>
        </td>
      </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<style scoped>

</style>